import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

/**
 * Layout wrapper for all public-facing routes.
 * Renders Header + page content + Footer.
 */
export default function PublicLayout() {
  return (
    <>
      <div className="App">
        <Header />
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
